import moment from 'moment';

export const convertBagReFlightLegDateTime = (
    dateString: string,
    timeString?: string
): string => {
    // When no time is provided, date-only inputs are formatted directly in UTC, so no 00:00:00 fallback is needed.
    const hasTime = !!timeString && timeString.length > 0;
    const date = moment.utc(
        hasTime ? `${dateString}T${timeString}` : dateString,
        moment.ISO_8601,
        true
    );

    return hasTime ? date.format('DD/MM HH:mm') : date.format('DD/MM');
};
